import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { Constants } from "Constants";
@Component({
  selector: 'app-whats-app-qr',
  templateUrl: './whats-app-qr.component.html',
  styleUrls: ['./whats-app-qr.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class WhatsAppQRComponent implements OnInit {
  url: any;
  constructor(
    private _fuseConfigService: FuseConfigService,
  ) {

    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    };

  }

  ngOnInit(): void {
    this.url = Constants.QR_URL
    setInterval(() => {
      this.url = Constants.QR_URL;
    }, 1000);
  }



}
